// This new payment form set up React Stripe.js and use Elements using react hooks.
// It is quite different from a normal class and state management.
import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { CardElement, Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { Button, Grid, TextField, Typography } from '@mui/material';
import Address from '../ui/Address'
import AppBindStyles from '../../AppBindStyles';
import EnvironmentDefs from '../../EnvironmentDefs';
import AbEnvironment from '../auth/AbEnvironment';
import AuditCreateMutation from '../notification/AuditCreateMutation';

import SaveButton from '../ui/SaveButton';



const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();
  const [cardDetails, setCardDetails] = useState({
    firstName: props.dFirstName,
    lastName: props.dLastName,
    address1: props.dAddress1,
    address2: props.dAddress2,
    city: props.dCity,
    state: props.dState,
    postalCode: props.dPostalCode,
    country: props.dCountry,
    pcId: props.pcId
  });
  const [saveInfo, setSaveInfo] = useState({
    saveStatus: null,
    saveMessage: null,
    cardError: false,
    cardMessage: ''
  });

  let address = {
    country:    cardDetails.country,
    state:      cardDetails.state,
    city:       cardDetails.city,
    postalCode: cardDetails.postalCode,
    address1:   cardDetails.address1,
    address2:   cardDetails.address2
  };
  let regionLabel = "Region";

  const handleSnackbarClose = (ev) => {
    setSaveInfo({ ...saveInfo, saveStatus: null }); 
  }

  const disablePaymentSubmit = () => {
    if (saveInfo.cardError) {
      return true;
    }
    return (!cardDetails.firstName ||
            !cardDetails.lastName ||
            !cardDetails.address1 ||
            !cardDetails.city ||
            !cardDetails.state ||
            !cardDetails.country ||
            !cardDetails.postalCode ||
            !stripe || !elements 
      );
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveInfo({ ...saveInfo, saveStatus: 'saving' }) 

    const abEnvironment = new AbEnvironment();

    const { callPartnerApi } = props.auth;

    // Need to create a source.
    let pcId        = cardDetails.pcId;
    let acctId      = props.dAccountId;
    let accountName = props.dAccountName;
    let cEmail      = props.dEmail;

    let errorObj = null;  // For sharing in chains
    let scId;             // For sharing in chains

    let aPjwt = abEnvironment.getPjwt();
    let success = false;

    Promise.resolve()
    .then(() => {
      // TODO - call Stripe source here!  Then only one call to our server
      // to attach (and create cust if needed).
      // Create the Stripe source
      return stripe.createSource(elements.getElement(CardElement),
        {
          type: 'card',
          owner: {
            address: {
              line1: cardDetails.address1,
              line2: cardDetails.address2,
              city: cardDetails.city,
              state: cardDetails.state,
              country: cardDetails.country,
              postal_code: cardDetails.postalCode
            },
            name:  cardDetails.firstName + ' ' + cardDetails.lastName,
            // email: this.state.email,
            // phone: this.state.phone,
          }
        }
      );
    })
    .then( (result) => {
      // Check for an error
      if (result.error != null)
      {
        let theError = result.error.message;
        if (theError == null) {
          theError = "Unidentified error creating Stripe source";
        }          
        errorObj = {
          'internalErr': theError,
          'externalErr': 'We were unable to verify your payment card.'
        }
        throw(errorObj);
      } 


      // Call attachStripeSource resource to
      // - create customer if needed
      // - attach the source to the customer
      let payload = {
        operation: "attachStripeSource",
        params: {
          pJwt:        aPjwt,
          accountId:   acctId,
          scId:        pcId,
          accountName: accountName,
          email:       cEmail,
          psCount:     props.porder,
          source:      result,
          firstName:   cardDetails.firstName,
          lastName:    cardDetails.lastName,
          address1:    cardDetails.address1,
          address2:    cardDetails.address2,
          city:        cardDetails.city,
          state:       cardDetails.state,
          country:     cardDetails.country,
        }
      };

      return callPartnerApi('appbind/generic',
                    'POST',
                    payload);
    }).then(resp => {
      if (resp.status === 200) {
        success = true;
      }
      return resp.json();
    }).then(data => {
      if (success) { 

        if (pcId == null) {
          scId = data.scId;
          //this.setState({ pcId: scId });
          props.setStripeCid(scId);
          // If this is the own user's account, need to set the dwolla id on
          // the env uinfo.
          if (acctId === abEnvironment.getUserAttribute('a_id')) {
            abEnvironment.setUserAttribute("a_stripeCid", scId);
          }
        }

      } else {
        throw(data);
      }

    })
    .then(() => {

        // Call checkAndAttachBindcards 
        // This backend operation might attach bindbards for any subscriptions created depending on other circumstances
        let payload = {
          operation: "checkAndAttachBindcards",
          params: {
            pJwt:        aPjwt,
            accountId:   acctId
          }
        };

        return callPartnerApi('appbind/generic',
                      'POST',
                      payload);
        

    })
    .then((response) => {
      success = true;
      return response;
      

    })
    .then((jresp) => {
      //console.log('Got here->' + JSON.stringify(jresp));
      if (success) {
        if (abEnvironment.isSegmentActive()) { window.analytics.track('Credit card save complete');  }   
    
        var subscriptionReturn = localStorage.getItem('subscriptionReturn');
        var paymentReturn = localStorage.getItem('paymentReturn');
        if (subscriptionReturn) {

          var subscriptionLink = '/subscription?customerAppId=' + subscriptionReturn + '&fp=Funding';
          localStorage.removeItem('subscriptionReturn');
          props.history.push (subscriptionLink);
        } else if (paymentReturn) {
          localStorage.removeItem('paymentReturn');
          props.history.push (paymentReturn);
          window.location.reload();

        } else {

          //this.setState({ saveStatus: 'success', saveMessage: null });
          window.location.reload();
  
        }

      } else {
        throw jresp;
      }
  

  
    })
    .catch(err => {
      //console.log(err);
      let internalError;
      //let externalError;
      if (err.internalErr)
      {
        internalError = err.internalErr;
       // externalError = err.externalErr;
      }
      else
      {
        internalError = err;
        //externalError = 'We were unable to verify your payment card.';
      }
      //the backend will tell front end if there is a status change.
      if (err.status) {
        abEnvironment.setUserAttribute("a_aStatus", err.status);
      }
      try {
        AuditCreateMutation.commit('Funding Source Add Failed', 'Credit Card add failure with reason: ' + internalError);
      } catch (e) {
        // Swallow exception, allow state change
      };
      //setSaveInfo({ ...saveInfo, saveStatus: 'error' }); 
      setSaveInfo({ ...saveInfo, saveMessage: 'Card not saved. ' + internalError, saveStatus: 'error' }); 
    });
    

  };

 
  const setCountry    = (country)    => { setCardDetails({ ...cardDetails, country: country }) }  
  const setRegion     = (region)     => { setCardDetails({ ...cardDetails, state: region }) }  
  const setCity       = (city)       => { setCardDetails({ ...cardDetails, city: city }) }  
  const setPostalCode = (postalCode) => { setCardDetails({ ...cardDetails, postalCode: postalCode }) }    
  const setAddress1   = (address1)   => { setCardDetails({ ...cardDetails, address1: address1 }) }  
  const setAddress2   = (address2)   => { setCardDetails({ ...cardDetails, address2: address2 }) }    

  const inputStyle = {
    fontSize: '20px',
  }

  
  return (
    <form className="Form">

      <Grid container spacing={2} justifyContent="flex-start" style={{marginTop:'5px'}}>
        <Grid item xs={12}>

            <div style={{paddingBottom:'7px',borderBottom:'1px solid rgba(0, 0, 0, 0.54)'}}>
              <Typography align="left" style={{color:'rgba(0, 0, 0, 0.54)', marginBottom:'7px'}}>
                Card number
              </Typography>
              <CardElement id="cardElement"
                onChange={event => {
                  if (event.error) {
                    //console.log(event.error.message);
                    setSaveInfo({ ...saveInfo, cardError: true, cardMessage: event.error.message }); 
                  } else {
                    //console.log('no error');
                    setSaveInfo({ ...saveInfo, cardError: false, cardMessage: '' });
                  }
                }}
                
                options={{
                  hidePostalCode: true,
                  style: {
                    base: inputStyle,
                  },
                }}
                />
            </div>
          </Grid>
          <Grid item xs={12}>
            <Typography align="left" style={{color:'red'}}>
                {saveInfo.cardMessage}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="space-around" style={{marginTop:'35px'}}>
          <Grid item xs={12} sm={6}>
            <TextField data-recording-ignore="mask"
              id="first-name" label="First name"
              value={ cardDetails.firstName }
              onChange={ (e) => { setCardDetails({ ...cardDetails, firstName: e.target.value }) }}
              inputProps={{ maxLength: 32 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField data-recording-ignore="mask"
              id="last-name" label="Last name"
              value={ cardDetails.lastName }
              onChange={ (e) => { setCardDetails({ ...cardDetails, lastName: e.target.value }) }}
              inputProps={{ maxLength: 32 }}
            />
          </Grid>
          <Grid item xs={12}>
            <Address
              address={address}
              regionLabel={regionLabel}
              setCountryCodeState={setCountry}
              setRegionCodeState={setRegion}
              setCityState={setCity}
              setPostalCodeState={setPostalCode}
              setAddress1State={setAddress1}
              setAddress2State={setAddress2}
            />
          </Grid>
          <Grid container spacing={3} direction="row" 
              justifyContent="flex-start"
              style={{marginTop:'20px',textAlign:'left'}}>
            <Grid item xs={12} align="center">

              <SaveButton
                snackbarOpen={saveInfo.saveStatus === 'error'}
                autoHideDuration={null}
                label="Save Card"
                size="large"
                status={saveInfo.saveStatus} 
                message={saveInfo.saveMessage}
                disabled={disablePaymentSubmit() === true}
                onSaveClick={handleSubmit}
                onSnackbarClose={handleSnackbarClose}/>
              


              <Button color="primary" variant="outlined" size="large" style={AppBindStyles.bottomButton} onClick={props.onClose}  >Cancel</Button>
            </Grid>
          </Grid>
        </Grid>
    </form>
  );
};

const ELEMENTS_OPTIONS = {
  fonts: [
    {
      cssSrc: "https://fonts.googleapis.com/css?family=Roboto:300,400,500"
    }
  ]
};

const envDefs = new EnvironmentDefs();

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(envDefs.getSkey());

const PaymentFormII = (props) => {
  return (
    <div className="AppWrapper">
      <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
        <CheckoutForm {...props}/>
      </Elements>
    </div>
  );
};

export default PaymentFormII;